import React, { Component } from 'react'
import ReactAutosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper'
import LinearProgress from '@material-ui/core/LinearProgress';
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import { debounce, uuid } from 'utils'

export class AutoSuggest extends Component {
  static defaultProps = {
    inputProps: {},
    onSuggestionsFetchRequested: () => {},
    labelProvider: item => `${item}`,
    value: null
  }

  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      suggestions: [],
      loading: 0
    }
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.value !== this.props.value){
      this.setState({value: this.props.value})
    }
  }

  handleHighlight = ({suggestion}) => {
    this.setState({highlightedSuggestion: suggestion})
  }

  handleBlur = (event, {highlightedSuggestion}) => {
    const bestSuggestion = highlightedSuggestion || this.state.highlighedSuggestion || this.state.suggestions[0]
    if(bestSuggestion){
      this.setState({suggestions: [], value: this.props.labelProvider(bestSuggestion)})
      this.props.onChange({target: { value: bestSuggestion}})
    }
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
      suggestions: newValue === '' ? [] : this.state.suggestions
    })
    if(!newValue){
      this.finishLoad(0)
      this.props.onChange({target: { value: null}})
    }
  }

  handleSuggestionSelected = (event, {suggestion}) => {
    this.props.onChange({target: { value: suggestion}})
    this.setState({suggestions: []})
    this.finishLoad(0)
  }

  finishLoad = (loadCounter=this.state.loading - 1) =>
    setTimeout(() => this.setState({loading: Math.max(0, loadCounter)}), 100)

  onSuggestionsFetchRequested = debounce(({ value }) => {
    this.props.onSuggestionsFetchRequested(value, (newValues) => {
        this.finishLoad()
        this.setState({
          suggestions: newValues.data ? newValues.data : newValues
        })
      },
      this.finishLoad
    )
    this.setState({loading: this.state.loading + 1})
  }, 300)

  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []})
  }

  getSectionSuggestions = ({suggestions, className}) =>
    suggestions.map(s => ({...s, className}))

  renderSuggestion = (suggestion, { query, isHighlighted })  => {
    const label = this.props.labelProvider(suggestion)
    const matches = match(label, query)
    const parts   = parse(label, matches)

    return (
      <MenuItem className={suggestion.className} selected={isHighlighted} component="div">
        <div>
          {parts.map((part, index) => {
            return part.highlight ? (
              <span key={index} style={{ fontWeight: 500, color: "#6AAEAA" }}>
                {part.text}
              </span>
            ) : (
              <strong key={index} style={{ fontWeight: 500 }}>
                {part.text}
              </strong>
            )
          })}
        </div>
      </MenuItem>
    )
  }

  renderSuggestionsContainer = ({ containerProps, children }) =>
    <Paper {...containerProps} className={`${containerProps.className} ${styles.suggestionsContainer}`}>
      {children}
      {this.state.loading ? <LinearProgress /> : false}
    </Paper>

  renderSectionTitle = ({title}) =>
    <Typography className={styles.sectionTitle} variant='subtitle1'>{title}</Typography>

  renderInput = ({ref, ...props}) =>
    <TextField {...props}/>

  render = () => {
    const {className, labelProvider, onSuggestionsFetchRequested, onChange, multiSection, ...inputProps } = this.props
    return (
      <ReactAutosuggest
        theme={{container: [className, styles.container].filter(c => c).join(' ')}}
        renderInputComponent={this.renderInput}
        inputProps={{
          ...inputProps,
          value: this.state.value || '',
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          fullWidth: true,
          autoComplete: uuid(),
        }}
        onBlur={this.handleBlur}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        onSuggestionHighlighted={this.handleHighlight}
        getSectionSuggestions={this.getSectionSuggestions}
        focusInputOnSuggestionClick={false}
        getSuggestionValue={this.props.labelProvider}
        renderSuggestion={this.renderSuggestion}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        renderSectionTitle={this.renderSectionTitle}
        multiSection={multiSection}
        containerProps={{className}}
      />
    )
  }
}

const styles = StyleSheet({
  container: {
    flex: 1,
  },
  suggestionsContainer: {
    '& ul': {
      padding: 0,
      listStyle: 'none',
      backgroundColor: '#212121'
    }
  },
  sectionTitle: {
    display: 'none',
    color: "rgba(255, 255, 255, 1)",
    fontSize: 16,
    background: "rgba(93, 93, 93, 0.7)",
    textAlign: "center",
    borderBottom: "3px solid rgba(232, 197, 109, 0.45)",
    marginBottom: -20
  }
})

export default AutoSuggest